import { useCallback } from "react";

import useRouteMatchURL from "../../../Components/hooks/useRouteMatchURL";

export const useEditLink = () => {
  const routeMatchURL = useRouteMatchURL();
  return useCallback((id: string) => `${routeMatchURL}/edit/${id}`, [routeMatchURL]);
};
